export default {"src":"/_next/static/media/apple.77cdbf31.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};